/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DeleteCompanyProductPermission$Params {

/**
 * ID spoločnosti
 */
  id: number;

/**
 * ID oprávnenia
 */
  permissionId: number;
}

export function deleteCompanyProductPermission(http: HttpClient, rootUrl: string, params: DeleteCompanyProductPermission$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
  const rb = new RequestBuilder(rootUrl, deleteCompanyProductPermission.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('permissionId', params.permissionId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
    })
  );
}

deleteCompanyProductPermission.PATH = '/admin/companies/{id}/product/{permissionId}';
